
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDefaultEquipmentIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 68,
  height: 68,
  viewBox: "0 0 68 68"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#B9B7B9",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M34.067.824c3.789.145 7.541.798 11.157 1.941a1.74 1.74 0 1 1-1.049 3.318 38.777 38.777 0 0 0-10.174-1.78C17.601 4.31 4.314 17.61 4.32 34.01c.006 16.4 13.303 29.69 29.703 29.687C50.423 63.695 63.715 50.4 63.715 34c0-8.264-3.744-15.932-10.381-22.57-.68-.68-.68-1.78 0-2.46.68-.68 1.78-.68 2.46 0 7.245 7.245 11.4 15.756 11.4 25.03 0 18.32-14.85 33.174-33.17 33.177C15.703 67.181.847 52.333.84 34.012.833 15.692 15.678.832 34.067.824z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49.084,
  cy: 7.277,
  r: 1.74
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.117 9.953c1.115-1.404 3.334-.405 3.088 1.313l-.024.133-3.585 16.733 7.822 1.642a4.979 4.979 0 0 1 3.599 3.002l.08.212a4.973 4.973 0 0 1-.685 4.61l-.144.184L28.505 60.05c-1.119 1.403-3.338.395-3.084-1.323l.025-.133 3.48-15.937a1.738 1.738 0 0 1 3.423.602l-.024.14-1.89 8.65 13.128-16.456c.298-.364.406-.845.297-1.297l-.044-.15a1.496 1.496 0 0 0-.971-.931l-.138-.036-9.534-2a1.741 1.741 0 0 1-1.368-1.927l.024-.14 2.393-11.179-10.08 12.696a1.498 1.498 0 0 0-.295 1.3l.045.15a1.5 1.5 0 0 0 .987.931l.142.036 7.411 1.583a1.739 1.739 0 0 1-.586 3.427l-.14-.024-7.395-1.58a4.977 4.977 0 0 1-3.021-7.822l.143-.184L36.117 9.953z"
}))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"68\" height=\"68\" viewBox=\"0 0 68 68\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g fill=\"#B9B7B9\" fill-rule=\"nonzero\">\r\n            <path d=\"M34.067.824c3.789.145 7.541.798 11.157 1.941.916.29 1.424 1.267 1.134 2.183-.29.917-1.267 1.424-2.183 1.135-3.319-1.05-6.763-1.649-10.174-1.78C17.601 4.31 4.314 17.61 4.32 34.01c.006 16.4 13.303 29.69 29.703 29.687C50.423 63.695 63.715 50.4 63.715 34c0-8.264-3.744-15.932-10.381-22.57-.68-.68-.68-1.78 0-2.46.68-.68 1.78-.68 2.46 0 7.245 7.245 11.4 15.756 11.4 25.03 0 18.32-14.85 33.174-33.17 33.177C15.703 67.181.847 52.333.84 34.012.833 15.692 15.678.832 34.067.824z\"/>\r\n            <circle cx=\"49.084\" cy=\"7.277\" r=\"1.74\"/>\r\n            <path d=\"M36.117 9.953c1.115-1.404 3.334-.405 3.088 1.313l-.024.133-3.585 16.733 7.822 1.642c1.63.339 2.977 1.469 3.599 3.002l.08.212c.553 1.566.287 3.3-.685 4.61l-.144.184L28.505 60.05c-1.119 1.403-3.338.395-3.084-1.323l.025-.133 3.48-15.937c.204-.938 1.131-1.533 2.07-1.328.892.194 1.473 1.04 1.353 1.93l-.024.14-1.89 8.65 13.128-16.456c.298-.364.406-.845.297-1.297l-.044-.15c-.158-.448-.52-.792-.971-.931l-.138-.036-9.534-2c-.896-.189-1.485-1.035-1.368-1.927l.024-.14 2.393-11.179-10.08 12.696c-.298.365-.405.847-.295 1.3l.045.15c.16.448.523.791.987.931l.142.036 7.411 1.583c.94.2 1.539 1.125 1.338 2.065-.19.892-1.034 1.478-1.924 1.362l-.14-.024-7.395-1.58c-1.708-.347-3.11-1.563-3.696-3.205-.56-1.567-.296-3.305.675-4.617l.143-.184L36.117 9.953z\"/>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/defaultEquipmentIcon.1e67f5ee967c6e677288a434831e174e.svg"),
        {
          React: SvgDefaultEquipmentIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      